import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';

interface OrderErrorProps {
  message: string;
  repeatOrderId?: number | null;
  chatLink?: string | null;
}

const AlertIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export default function OrderError({ message, repeatOrderId, chatLink }: OrderErrorProps) {
  return (
    <MainLayout>
      <Head title="Error | Abasto Virtual">
        <meta name="robots" content="noindex" />
      </Head>

      <div className="flex min-h-[60vh] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
            <AlertIcon className="h-8 w-8 text-amber-500" />
          </div>

          <p className="mb-6 text-gray-700">{message}</p>

          <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            {repeatOrderId && (
              <Link
                href={`/pedido/${repeatOrderId}/repetir`}
                className="inline-block rounded-xl bg-green-500 px-5 py-3 font-semibold text-white transition-colors hover:bg-green-600"
              >
                Repetir Pedido
              </Link>
            )}
            {chatLink && (
              <a
                href={chatLink}
                target="_blank"
                rel="noopener"
                className="inline-block rounded-xl bg-blue-500 px-5 py-3 font-semibold text-white transition-colors hover:bg-blue-600"
              >
                Contactar Soporte
              </a>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
